/* eslint-disable */
import anime from 'animejs';

export default {
  init() {
    // scripts here run on the DOM load event
  },
  finalize() {
    // scripts here fire after init() runs

    const button = document.querySelector('.btn');
    const scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement;

    /* eslint-disable */
    $('.anchor-menu-list').each(function(){

        $(this).find('a').each(function(){

          $(this).click(function(event){

            event.preventDefault();
            var anchorTag = $(this).attr('href');
            var animateTo = $(anchorTag);

            // console.log(animateTo.offset());
            anime({
               targets: scrollElement,
               scrollTop: animateTo.offset().top,
               duration: 1200,
               easing: 'easeInOutQuart'
             });


          });

        });
    });

    var anchorTransition = 200;
    var staggerTiming = 20;

    $('.anchor-menu .toggle').on('click', function() {

      if ($(this).closest('.anchor-menu').hasClass('-expanded')) {
        anime({
          targets: ['.anchor-menu .anchor-dropdown .anchor-item'],
          translateY: [0, '-2rem'],
          opacity: [1, 0.01],
          easing: 'easeInOutCubic',
          delay: anime.stagger(staggerTiming, {from: 'first'}),
          duration: anchorTransition
        });

        var menuHeight = $(this).closest('.anchor-menu').find('.anchor-dropdown').outerHeight() + 'px';

        anime({
          targets: ['.anchor-menu .anchor-dropdown'],
          maxHeight: [menuHeight, 0],
          easing: 'easeInOutCubic',
          duration: anchorTransition
        });

        setTimeout(() => {
          $(this).closest('.anchor-menu').removeClass('-expanded');
          $('.anchor-menu .anchor-dropdown').css('max-height', '');
        }, anchorTransition);

        // setTimeout(() => {
        //   $(this).closest('.anchor-menu').find('.anchor-dropdown').css('max-height', 'none');
        // }, 400);

      } else {
        $('.anchor-menu .anchor-dropdown').css('max-height', '');
        $(this).closest('.anchor-menu').addClass('-expanded');

        anime({
          targets: ['.anchor-menu .anchor-dropdown .anchor-item'],
          translateY: ['-2rem', 0],
          opacity: [0.01, 1],
          easing: 'easeInOutCubic',
          delay: anime.stagger(staggerTiming, {from: 'last'}),
          duration: anchorTransition
        });
      }
    });

    // var windowWidth = $(window).width();
    //
    // $(window).on('resize', function() {
    //   windowWidth = $(window).width();
    //
    //   if (windowWidth >= 744) {
    //     $('.anchor-menu .anchor-dropdown').css('max-height', '');
    //     $('.anchor-menu .anchor-dropdown .anchor-item').css('opacity', '');
    //   }
    // });

  },
};



// WEBPACK FOOTER //
// ./scripts/components/anchor.js